import axios from 'axios'
import { store } from '../store'
import { setStyles } from '../store/actions/styles.actions'
import { STYLES_URL } from './constants'
// eslint-disable-next-line import/prefer-default-export
export const getStyles = async () => {
  const { styles } = store.getState()
  try {
    const instance = axios.create()
    const response = await instance.get(`${STYLES_URL}/${styles.version}/false`)
    store.dispatch(setStyles(response.data))
  } catch (error) {
    console.log(error)
  }
}

export const getDynamicStyle = (stylesObject) => {
  const styles = {}
  if (stylesObject === null || stylesObject === undefined) {
    return {}
  }
  for (const prop in stylesObject) {
    if (prop === 'text' || prop === 'startColor' || prop === 'endColor') {
      continue
    }
    if (prop === 'borderWidth') {
      styles[prop] = stylesObject[prop] + 'px !important'
    } else {
      styles[prop] = stylesObject[prop] + ' !important'
    }
  }
  return styles
}

export const getGradientColors = (colors, important = false) => {
  if (colors?.startColor === undefined || colors?.endColor === undefined) {
    return {}
  }
  const gradientColors = {
    background: `linear-gradient(90deg, ${colors.startColor}, ${colors.endColor}) ${
      important ? '!important' : ''
    }`,
  }
  return gradientColors
}
